import React from "react";
import { Chip, Divider, Modal, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Button from "components/atoms/Button";
import { CoverageAreaProps } from "store/modules/Logistics/types.store";
import * as Styled from "../styles";
import { SelectedDayInfo, WEEK_DAYS, WeekDayKey } from "../types";

interface ConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedAreas: CoverageAreaProps[];
  selectedDays: SelectedDayInfo[];
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  selectedAreas,
  selectedDays,
}) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose}>
      <Styled.ConfirmationModalContainer>
        <Typography variant="h6">Atenção</Typography>
        <Typography variant="body2">
          O novo horário será aplicado em todas as áreas de cobertura
          selecionadas. Deseja salvar estas alterações?
        </Typography>
        <Divider sx={{ borderColor: "black" }} />
        <Typography variant="body2" fontWeight="bold">
          Revendas selecionadas:
        </Typography>
        <Styled.ChipsContainer>
          {selectedAreas.map((coverageArea) => (
            <Chip
              variant="outlined"
              key={coverageArea.id}
              label={coverageArea.name}
            />
          ))}
        </Styled.ChipsContainer>
        <Typography variant="body2" fontWeight="bold">
          Dias alterados:
        </Typography>
        <Styled.ConfirmationModalTableContainer>
          <Styled.ConfirmationModalTableHeader>
            <Styled.ConfirmationModalTableHeaderCell>
              Dia
            </Styled.ConfirmationModalTableHeaderCell>
            <Styled.ConfirmationModalTableHeaderCell>
              Abre
            </Styled.ConfirmationModalTableHeaderCell>
            <Styled.ConfirmationModalTableHeaderCell>
              Fecha
            </Styled.ConfirmationModalTableHeaderCell>
            <Styled.ConfirmationModalTableHeaderCell>
              Status
            </Styled.ConfirmationModalTableHeaderCell>
          </Styled.ConfirmationModalTableHeader>
          {selectedDays.map((dayData) => (
            <Styled.ConfirmationModalTableRow key={dayData.day}>
              <Styled.ConfirmationModalTableCell>
                <Typography
                  variant="body2"
                  fontWeight="bold"
                  color="primary.main"
                >
                  {dayData.day === "Holiday"
                    ? dayData.dayName
                    : t(WEEK_DAYS[dayData.day as WeekDayKey].toLowerCase())}
                </Typography>
              </Styled.ConfirmationModalTableCell>
              <Styled.ConfirmationModalTableCell>
                <Typography variant="body2">
                  {dayData.isOpen ? dayData.open : "-"}
                </Typography>
              </Styled.ConfirmationModalTableCell>
              <Styled.ConfirmationModalTableCell>
                <Typography variant="body2">
                  {dayData.isOpen ? dayData.close : "-"}
                </Typography>
              </Styled.ConfirmationModalTableCell>
              <Styled.ConfirmationModalTableCell>
                <Typography variant="body2">
                  {dayData.isOpen ? "Aberto" : "Fechado"}
                </Typography>
              </Styled.ConfirmationModalTableCell>
            </Styled.ConfirmationModalTableRow>
          ))}
        </Styled.ConfirmationModalTableContainer>
        <Styled.ConfirmationModalButtonsContainer>
          <Button variant="outlined" color="inherit" onClick={onClose}>
            Cancelar
          </Button>
          <Button variant="contained" color="primary" onClick={onConfirm}>
            Confirmar
          </Button>
        </Styled.ConfirmationModalButtonsContainer>
      </Styled.ConfirmationModalContainer>
    </Modal>
  );
};

export default React.memo(ConfirmationModal);
